import { Link } from "react-router-dom";
import PortalLayout from "../../components/PortalLayout";
import { useI18n } from "../../i18n/LanguageContext";
import { PHILOSOPHY } from "./exploreContent";

export default function ExplorePhilosophyPage() {
  const { locale, t } = useI18n();
  const c = PHILOSOPHY[locale] || PHILOSOPHY.it;

  return (
    <PortalLayout>
      <section
        className="max-w-[1080px] mx-auto px-6 sm:px-8 pt-14 pb-8"
        data-testid="explore-philosophy-page"
      >
        <Link
          to="/explore"
          className="font-mono-fin text-[0.7rem] tracking-[0.2em] uppercase text-[color:var(--br-bronze-soft)] hover:text-[color:var(--br-bronze)]"
          data-testid="explore-back-link"
        >
          {t("explore.back")}
        </Link>

        <div className="br-fade-up mt-7">
          <div className="br-overline">{c.eyebrow}</div>
          <h1 className="font-serif-display text-[clamp(2.4rem,4.5vw,3.8rem)] mt-3 leading-[1.05]">
            {c.title}
          </h1>
        </div>

        <div className="mt-10 max-w-[760px] br-fade-up br-delay-1">
          <p
            className="font-serif-display italic text-[1.5rem] text-[color:var(--br-parchment)] leading-[1.5] mb-8"
            data-testid="philosophy-lead"
          >
            {c.lead}
          </p>
          <p className="text-[1.02rem] text-[color:var(--br-text)] mb-6 leading-relaxed">{c.p1}</p>
          <p className="text-[1.02rem] text-[color:var(--br-text)] leading-relaxed">{c.p2}</p>
        </div>

        <div className="mt-16 br-fade-up br-delay-2">
          <div className="br-overline">{c.how_eyebrow}</div>
          <h2 className="font-serif-display text-[2rem] mt-3 mb-8">{c.how_title}</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="philosophy-steps">
            {c.steps.map((s, i) => (
              <div key={i} className="br-card p-6">
                <div
                  className="font-mono-fin text-[0.6rem] tracking-[0.28em] uppercase"
                  style={{ color: "var(--br-bronze)" }}
                >
                  {s.num}
                </div>
                <h3 className="font-serif-display text-[1.3rem] mt-3 text-[color:var(--br-parchment)]">
                  {s.t}
                </h3>
                <p className="text-[0.9rem] text-[color:var(--br-text-dim)] mt-3 leading-relaxed">
                  {s.d}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 br-fade-up br-delay-3">
          <div className="br-overline">{c.comparison_eyebrow}</div>
          <h2 className="font-serif-display text-[2rem] mt-3 mb-8">{c.comparison_title}</h2>
          <div className="br-card overflow-x-auto" data-testid="philosophy-comparison">
            <table className="w-full text-left">
              <thead>
                <tr style={{ borderBottom: "1px solid var(--br-line)" }}>
                  <th className="px-5 py-4 font-mono-fin text-[0.62rem] tracking-[0.22em] uppercase text-[color:var(--br-text-dim)]">
                    {c.comparison_traditional}
                  </th>
                  <th
                    className="px-5 py-4 font-mono-fin text-[0.62rem] tracking-[0.22em] uppercase"
                    style={{ color: "var(--br-bronze)" }}
                  >
                    {c.comparison_family}
                  </th>
                </tr>
              </thead>
              <tbody>
                {c.comparison_rows.map((row, i) => (
                  <tr key={i} className="border-b" style={{ borderColor: "var(--br-line)" }}>
                    <td className="px-5 py-4 text-[0.95rem] text-[color:var(--br-text-dim)]">
                      {row[0]}
                    </td>
                    <td className="px-5 py-4 text-[0.95rem] text-[color:var(--br-parchment)]">
                      {row[1]}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </PortalLayout>
  );
}
